<template>
  <div>
    <el-tag v-for="tag in tags" :class="$style.tag" :key="tag.id">
      {{ tag.name }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: ["colData"],
  computed: {
    tags() {
      return this.colData.row.tags.slice(0, 3);
    },
  },
};
</script>

<style lang="scss" module>
.tag {
  margin: 0 5px;
}
</style>